export var DEFAULT_COLOR = ['#FAAD14', '#E8EDF3'];
//# sourceMappingURL=constant.js.map